PageApp.Views.ExchangeRatesView = Marionette.CollectionView.extend({
  childView: PageApp.Views.ExchangeRateView,
  className: 'w2-exchange-rate-box',
  initialize: function (options) {
    this.collection = options.collection
  }
})
